import NetworkQualityImg from "../assets/aboutus/images/NetworkQualityImg.png";
import OurVisionImg from "../assets/aboutus/images/OurVision.jpg";
import AboutUsImage from "../assets/aboutus/images/AboutUs.jpg";
import AboutUsGoalTab from "../assets/aboutus/images/AboutUsGoalTab.jpg";
import AboutUsMissionTab from "../assets/aboutus/images/AboutUsMissionTab.jpg";

export const tabs = ["Vision", "Goal", "Mission"];

export const tabsContent = [
  {
    title: "Vision",
    img: OurVisionImg,
    disc: `Vis Group aims to be the preferred choice for clients in 
    telecommunications and technology services. With offices spanning Europe,
     Asia, and the Middle East, we provide innovative solutions in network benchmarking,
      field performance testing, infotainment systems testing, HMI testing, SOS emergency
      calls testing, certification forums, software development, and more.
      By utilizing our expertise and cultivating strong client partnerships,
       we strive to shape the technological landscape, drive innovation,
       and empower businesses globally to achieve seamless connectivity and success.`,
  },
  {
    title: "Goal",
    img: AboutUsGoalTab,
    disc: `At Vis Group, our goal is to become the premier choice for clients 
    seeking excellence in telecommunications and technology services.
    With a presence across Europe, Asia, and the Middle East, we deliver cutting-edge
      solutions in areas such as network benchmarking, field performance testing,
       infotainment systems testing, HMI testing, SOS emergency calls testing,
       certification forums, software development, and beyond. By leveraging our deep
       expertise and building strong partnerships with our clients, we aim to shape
        the future of technology, foster innovation, and enable businesses worldwide
         to achieve seamless connectivity and outstanding success.`,
  },
  {
    title: "Mission",
    img: AboutUsMissionTab,
    disc: `Our mission at Vis Group is to deliver unparalleled telecommunications and
     technology services that drive innovation and foster seamless connectivity.
     We are committed to providing our clients with advanced solutions in network
     benchmarking, field performance testing, infotainment systems testing,
      HMI testing, SOS emergency calls testing, certification forums,
      and software development. By leveraging our extensive expertise and building
      strong, collaborative partnerships, we strive to empower businesses worldwide,
       enabling them to achieve their goals and succeed in an increasingly connected world`,
  },
];

export const networkQualityPassion = {
  title: "Your Network Quality is our Passion",
  img: NetworkQualityImg,
  disc: `Vis Group team of quality experts identifies opportunities to apply technology solutions that provide you with a customizable framework and an integrated testing strategy with your development lifecycle. By leveraging cutting-edge tools and methodologies, we tailor our solutions to meet your unique needs, ensuring that you achieve optimal performance, reliability, and user satisfaction. Our commitment to excellence and continuous improvement drives us to deliver exceptional value, helping you navigate complex challenges and stay ahead in a competitive market.`,
};

export const aboutVisGroup = {
  title: "About Vis Group",
  img: AboutUsImage,
  disc: `
  We’ve been helping customers globally.Develop and Test your digital
                products and solutions with Vis Group, a leading provider of
                end-to-end testing and quality assurance services. Operating
                across Europe,gulf and Asia, we offer comprehensive testing
                solutions that ensure the flawless performance of your digital
                offerings. From telecommunication system testing to network
                benchmarking, infotainment systems testing, and software
                testing,software development and AI systems. our expert team leverages their domain knowledge to
                deliver superior results. With Vis Group, you can trust in our
                meticulous testing processes and experienced professionals to
                provide your end-users with a seamless and exceptional
                experience. Let us validate and optimize your digital solutions
                for unparalleled success.
  `,
};
